import { api } from './apiProvider';

export interface PaymentListItem {
  id: string;
  status: string;
  amount: number;
  method: string;
  paymentType: string;
  paymentDate: Date | null;
  last4: string;
  invoiceNumber: number;

  [key: string]: string | number | Date | null;
}

export interface PayInvoicesRequest {
  invoiceIds: string[];
  paymentMethodId: string;
}

export async function listPayments(): Promise<PaymentListItem[]> {
  return await api
    .get('payments', {
      credentials: 'include',
    })
    .json<PaymentListItem[]>();
}

export async function payInvoices(request: PayInvoicesRequest) {
  await api.post('payments', {
    credentials: 'include',
    json: request,
  });
}
